import { useEffect, useContext, useCallback } from 'react';

import FirebaseContext from '../../context/FirebaseContext';
import useSessionStore from '../../hooks/useSessionStore';
import UserStatus from '../../Model/UserStatus';

const ActiveUserTracker = () => {
  const { userId, isInsideSales } = useSessionStore();
  const { firebase } = useContext(FirebaseContext);

  // Handles tab visibility changes (user switches tab, minimizes or sleeps the device)
  const handleVisibilityChange = useCallback(async () => {
    if (firebase.userStatusRef) {
      if (document.hidden) {
        await firebase.userStatusRef.removeTabSession();
      } else {
        await firebase.userStatusRef.createTabSession();
      }
    }
  }, [firebase]);

  useEffect(() => {
    if (!userId || !firebase || !isInsideSales) return;

    let cleanup = null;

    const init = async () => {
      const userStatus = new UserStatus(firebase, userId);
      // store userStatus instance in firebase
      firebase.userStatusRef = userStatus;

      // Setup presence tracking
      const presenceTracking = await userStatus.trackPresence();
      cleanup = presenceTracking.cleanup;

      document.addEventListener('visibilitychange', handleVisibilityChange);
    };

    init();
    // eslint-disable-next-line consistent-return
    return () => {
      if (cleanup) cleanup();
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [userId, firebase, isInsideSales, handleVisibilityChange]);

  return null;
};

export default ActiveUserTracker;
